import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import coin from '@/assets/icons/coin-icn-xs.svg';
import key from '@/assets/icons/key-icn-xs.svg';
import star from '@/assets/icons/star-icn-xs.svg';
import { Mission, MissionItem } from '@/components/Mission';
import { ProgressBar } from '@/components/ProgressBar';
import { MissionQuest } from '@/types/models/mission';
import { formatNumber } from '@/utils/format';

export type QuestMissionProps = {
  mission: MissionQuest;
  completed: boolean;
  onClick: () => void;
};

export const Quest = observer<QuestMissionProps>(
  ({ mission, onClick, completed }) => {
    const { t } = useTranslation();
    return (
      <Mission
        name={t(mission.name)}
        icon={mission.icon}
        completed={completed}
        onClick={onClick}
        missionBar={
          <>
            {mission.coins && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.coins)}`}</span>
                <img src={coin} />
              </MissionItem>
            )}
            {mission.keys && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.keys)}`}</span>
                <img src={key} />
              </MissionItem>
            )}
            {mission.xp && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.xp)}`}</span>
                <img src={star} />
              </MissionItem>
            )}
          </>
        }
        missionFooter={
          <ProgressBar
            width={Number(((mission.done / mission.target) * 100).toFixed(0))}
            title={t(mission.title)}
            topProgress={`${mission.done}/${mission.target}`}
          />
        }
      />
    );
  },
);
